(function () {
  function initVariantPreviewFloat() {
    if (!window.theme || !theme.pubsub || !theme.pubsub.PUB_SUB_EVENTS) return;

    const floats = document.querySelectorAll('.variant-preview-float');

    floats.forEach(function (float) {
      const sectionId = float.dataset.sectionId;
      const productId = float.dataset.productId;
      const img = float.querySelector('img');
      const nameBar = float.querySelector('.vpf-bar--bottom');
      const gallery = document.getElementById('ProductGallery-' + sectionId + '-' + productId);
      const picker = document.getElementById('VariantPicker-' + sectionId + '-' + productId);

      if (!gallery || !img) return;

      function updateVisibility() {
        const galleryAbove = gallery.getBoundingClientRect().bottom < 0;
        const pickerAbove = picker ? picker.getBoundingClientRect().bottom < 0 : false;

        if (galleryAbove && !pickerAbove) {
          float.classList.add('vpf-visible');
        } else {
          float.classList.remove('vpf-visible');
        }
      }

      window.addEventListener('scroll', updateVisibility, { passive: true });
      updateVisibility();

      // Update image and color name on variant change
      theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.variantChange, function (event) {
        if (event.data.sectionId !== sectionId) return;

        const variant = event.data.variant;
        if (variant && variant.featured_image && variant.featured_image.src) {
          const src = variant.featured_image.src;
          img.src = src.includes('?') ? src + '&width=300' : src + '?width=300';
          img.alt = variant.title || '';
        }
        if (nameBar) {
          nameBar.textContent = variant.options ? variant.options[0] : (variant.title || '');
        }
      });

      // Tap to scroll back to gallery
      float.addEventListener('click', function () {
        gallery.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVariantPreviewFloat);
  } else {
    initVariantPreviewFloat();
  }
})();
